export default {"src":"/_next/static/media/italic_filled.e8c5dd88.svg","height":24,"width":24};